import { useState, useEffect } from 'react'
// @ts-ignore
import placeholderDark from '#images/image-placeholder-dark.jpg'
import placeholderLight from '#images/image-placeholder.jpg'
import { useTheme } from '#app/utils/providers/themeProvider'

const Image = ({
	containerClassName,
	className,
	imageUrl,
	imageAlt,
	noFallback = false,
}: {
	containerClassName?: string
	className: string
	imageUrl?: string
	imageAlt: string
	noFallback?: boolean
}) => {
	const [theme] = useTheme()
	const [imageLoaded, setImageLoaded] = useState(true)
	const [imageSrc, setImageSrc] = useState(
		imageUrl ? imageUrl : noFallback ? null : ( theme === 'dark' ? placeholderDark : placeholderLight),
	)

	// Update imageSrc when imageUrl changes
	useEffect(() => {
		if (imageUrl) {
			setImageSrc(imageUrl)
			setImageLoaded(true)
		} else {
			setImageSrc(noFallback ? null : ( theme === 'dark' ? placeholderDark : placeholderLight))
		}
	}, [imageUrl, theme])

	const handleImageError = () => {
		setImageLoaded(false)
		setImageSrc(noFallback ? null : ( theme === 'dark' ? placeholderDark : placeholderLight))
	}

	return (
		<div className={containerClassName}>
			{imageLoaded ? (
				<img
					className={className}
					src={imageSrc}
					alt={imageAlt}
					onError={handleImageError}
				/>
			) : (
				<img
					className={className}
					src={theme === 'dark' ? placeholderDark : placeholderLight}
					alt={imageAlt}
				/>
			)}
		</div>
	)
}

export default Image
